module.exports = __webpack_public_path__ + "static/1188864563.2981d072.jpg";